import { signal } from "@preact-signals/safe-react";

import { UserRolePermissions } from "@pdpp/lib-planta";

export const userPermissions$ = signal<UserRolePermissions>({
  roles: [],
  permissions: [],
  orgs: [],
});
